// extracted by mini-css-extract-plugin
export default {"card":"OrderCard_card__hSCTH","order-id":"OrderCard_order-id__G7Eam","status":"OrderCard_status__LgfF1","total":"OrderCard_total__3TSEl"};